
<template>
  <div class="market">
    <img src="../../assets/img/vip/activePage2.png"
         alt="">
  </div>
</template>

<script>

export default {
  name: 'market',
  components: {
  },
  data () {
    return {

    }
  },
  mounted () {
    this.util.title('关注公众号');
  },
  methods: {

  }

}
</script>
<style scoped>
.market {
  width: 100%;
  height: 100vh;
  background: #ff5840;
  padding: 0;
  margin: 0;
}
.market img {
  width: 100%;
}
</style>
